/** .........
 * The name of the bundled audio file which will be played for the incoming user requests for
 * joining  the conference
 *
 * @type {string}
 */
export const USER_WAITING_REGISTER = 'USER_WAITING_REGISTER';


/** .........
  * The name of the bundled audio file which will be played for the incoming user requests for
  * joining  the conference
  *
  * @type {string}
  */
export const USER_WAITING_SOUND = 'meet-hour-waiting.mp3';
